import Model, { attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type StringTransform from 'teacher-ui-client/transforms/string'
import type NumberTransform from 'teacher-ui-client/transforms/number'

/**
 * id should match that of a student from gravity
 */
export default class StudentStat extends Model {
  @attr<StringTransform>('string') declare firstName: string

  @attr<StringTransform>('string') declare lastName: string

  @attr<NumberTransform>('number') declare gradePosition: number

  @attr<StringTransform>('string') declare schoolClassNames: string

  @attr<NumberTransform>('number') declare activeSharesCollectionCount: number

  @attr<NumberTransform>('number') declare pendingSharesCollectionCount: number

  @attr<NumberTransform>('number') declare expiredSharesCollectionCount: number;

  [Type] = 'book-library/student-stat' as const
}
